import { render, staticRenderFns } from "./MintNotificationBell.vue?vue&type=template&id=24f27a1c&scoped=true"
import script from "./MintNotificationBell.vue?vue&type=script&lang=js"
export * from "./MintNotificationBell.vue?vue&type=script&lang=js"
import style0 from "./MintNotificationBell.vue?vue&type=style&index=0&id=24f27a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f27a1c",
  null
  
)

export default component.exports